import { actions } from "app/publicDictionaryValues";
import myRequestListService from "service/myRequestListService";
import ProcedureDetailService from "service/procedureFile/ProcedureDetailService";
import { IRoute } from "utils/highlight/types";
import { wrapRequestToPromise } from "utils/index";
import solveApproveHighlight from "./route/approve";
import solveReturnHighlight from "./route/return";
import solveReviseHighlight from "./route/revise";
import solveSubmitHighlight from "./route/submit";
import { IResult } from "./types";
import { needCheckStepActions } from "./utils";

const generate = async (params: IRoute["param"]): Promise<IResult> => {
  const { ParentPage, ProcedureID, ProcedureStepID, ProcedureTaskId } = params;
  // use cache to reduce request
  const currflowStepdata = await wrapRequestToPromise(ProcedureDetailService.getFlowStepData)({
    taskID: ProcedureTaskId,
    procedureID: ProcedureID,
    procedureStepID: ProcedureStepID,
    parentPage: ParentPage,
  });
  if (!currflowStepdata) return;
  const { processID, procedureStepID, actionID, procedureFileProcedureStepId } = currflowStepdata;

  if (needCheckStepActions.indexOf(actionID) === -1) return;

  // use cache to reduce request
  const currfileStepData = await ProcedureDetailService.getProcedureFolderStepItemSingle({
    taskID: ProcedureTaskId,
    procedureID: ProcedureID,
    procedureStepID: ProcedureStepID,
    parentPage: ParentPage,
  });
  if (!currfileStepData) return;

  if (actionID === actions.submit) {
    const prevfileStepData = await ProcedureDetailService.getProcedureFolderStepItemSingle({
      taskID: ProcedureTaskId,
      procedureID: ProcedureID,
      procedureStepID: procedureFileProcedureStepId,
      parentPage: ParentPage,
    });
    return solveSubmitHighlight({ currfileStepData, prevfileStepData });
  }
  // not submit, then get previous step from process detail
  const processData = await wrapRequestToPromise(myRequestListService.getProcessDetailData)({
    processID,
  });
  if (!processData) return;
  const { stepData } = processData;
  let currStepIndex = stepData.findIndex((step) => step.procedureStepID === procedureStepID);
  let prevStepIndex = currStepIndex - 1;
  const isSecondApprovalStep = stepData[currStepIndex].step === "Approval" && stepData[prevStepIndex].step === "Approval";

  if (isSecondApprovalStep) {
    prevStepIndex = (() => {
      for (let i = prevStepIndex - 1; i > 0; i--) {
        if (stepData[i].owner === stepData[currStepIndex].owner) {
          return i;
        }
      }
      return 0;
    })();
  }

  const { procedureStepID: prevProcedureStepID } = stepData[prevStepIndex];

  const prevfileStepData = await ProcedureDetailService.getProcedureFolderStepItemSingle({
    taskID: ProcedureTaskId,
    procedureID: ProcedureID,
    procedureStepID: prevProcedureStepID,
    parentPage: ParentPage,
  });
  if (isSecondApprovalStep) {
    const temp = await ProcedureDetailService.getProcedureFolderStepItemSingle({
      taskID: ProcedureTaskId,
      procedureID: ProcedureID,
      procedureStepID: stepData[currStepIndex - 1].procedureStepID,
      parentPage: ParentPage,
    });
    prevfileStepData.isChangeLevelC = temp.isChangeLevelC;
    prevfileStepData.revisionFormInfo = temp.revisionFormInfo;
  }

  if (actionID === actions.return) {
    return solveReturnHighlight({ currfileStepData, prevfileStepData });
  } else if (actionID === actions.revise) {
    return solveReviseHighlight({ currfileStepData, prevfileStepData });
  } else if (actionID === actions.approve) {
    return solveApproveHighlight({ currfileStepData, prevfileStepData });
  }
};
export default generate;
